import {
  // AdAnalyticsDailyPerformance,
  // AdAnalyticsVideo,
  AdAnalyticsVideoFilter,
  AdAnalyticsVideoSort,
} from '@kaizenplatform/hugot-entity';
import { List } from 'immutable';

import State from '../core/State';
import CreativePerformanceBrowsingAd from '../entity/CreativePerformanceBrowsingAd';
import CreativePerformanceBrowsingCampaign from '../entity/CreativePerformanceBrowsingCampaign';
import CreativePerformanceBrowsingCreative from '../entity/CreativePerformanceBrowsingCreative';
import WithTotalCountArrayPageInfo from '../entity/WithTotalCountArrayPageInfo';

export const startFetchingCreativePerformanceCreatives = () => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    fetching: state.creativePerformanceCreatives.fetching + 1,
  },
});

export const finishFetchingCreativePerformanceCreatives = () => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    fetching: state.creativePerformanceCreatives.fetching - 1,
  },
});

export const startFetchingAppendCreativePerformanceCreatives = () => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    appendFetching: state.creativePerformanceCreatives.fetching + 1,
  },
});

export const finishFetchingAppendCreativePerformanceCreatives = () => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    appendFetching: state.creativePerformanceCreatives.fetching - 1,
  },
});

export const setCreativePerformanceCreatives = (
  creativePerformanceCreatives: List<CreativePerformanceBrowsingCreative>,
  pageInfo: WithTotalCountArrayPageInfo,
) => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    creatives: creativePerformanceCreatives,
    pageInfo,
  },
});

export const setCreativePerformanceCampaigns = (
  creativePerformanceCampaigns: List<CreativePerformanceBrowsingCampaign>,
  pageInfo: WithTotalCountArrayPageInfo,
) => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    campaigns: creativePerformanceCampaigns,
    pageInfo,
  },
});

export const setCreativePerformanceAds = (
  creativePerformanceAds: List<CreativePerformanceBrowsingAd>,
  pageInfo: WithTotalCountArrayPageInfo,
) => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    ads: creativePerformanceAds,
    pageInfo,
  },
});

export const appendCreativePerformanceCreatives = (
  creativePerformanceCreatives: List<CreativePerformanceBrowsingCreative>,
  pageInfo: WithTotalCountArrayPageInfo,
) => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    creatives:
      state.creativePerformanceCreatives.creatives === null
        ? creativePerformanceCreatives
        : state.creativePerformanceCreatives.creatives.concat(creativePerformanceCreatives),
    pageInfo: pageInfo,
  },
});

export const disposeCreativePerformanceCreatives = () => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
  },
});

export const setPerPage = (perPage: number) => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    perPage,
  },
});

export const setCurrentPage = (currentPage: number) => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    currentPage,
  },
});

export const updateFilters = (filters: AdAnalyticsVideoFilter[]) => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    filters: filters,
  },
});

export const updateSortCreativePerformanceCreatives = (sort: AdAnalyticsVideoSort) => (state: State): State => ({
  ...state,
  creativePerformanceCreatives: {
    ...state.creativePerformanceCreatives,
    sort: sort,
  },
});
